import { FC } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

type Props = {
  srcs: string[];
};

const SampleImageFadeCaoursel: FC<Props> = ({ srcs }): JSX.Element => {
  return (
    <Splide
      className="rounded-l-lg overflow-hidden"
      options={{
        drag: false,
        type: "fade",
        perPage: 1,
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
      }}
    >
      {srcs.map((src) => (
        <SplideSlide key={src}>
          <img className="w-full h-auto " src={src} />
        </SplideSlide>
      ))}
    </Splide>
  );
};
export default SampleImageFadeCaoursel;
